import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import CallingYouToConnectYouWith from 'src/components/View/ModalDialogForm/CallingYouToConnectYouWith';
import SelectNumberToCall from 'src/components/View/ModalDialogForm/SelectNumberToCall';
import ModalDialog from 'src/components/ModalDialog/index';
import ModalDialogVideo from 'src/components/ModalDialogVideo';
import AddCategoryModal from 'src/views/management/CustomerDetailsView/ModalForms/AddCategoryModal';
import ExecuteKeywordModal from 'src/views/management/CustomerDetailsView/ModalForms/ExecuteKeywordModal';
import AddToGroupModalChat from 'src/views/management/ChatView/ChatDetails/ModalForms/AddToGroupModalChat';
import {
  callFromCP,
  setValuesFormExecuteKeyword,
  sendExecuteKeyword,
  setValuesFormAddToGroup,
  getContactGroups,
  sendAddContactToAGroup,
} from 'src/actions/customerDetailsActions';
import {
  getCustomerCategories,
  sendAddCustomerCategories,
  setCustomerCategoriesQuery,
  setValuesFormAddCustomerCategories,
} from 'src/actions/customerCategoriesActions';
import { addNotification } from 'src/actions/notificationActions';
import { NOTIFICATION_STATUS } from 'src/constants';
import { CONTACT_MODAL_FORM_NAMES } from 'src/constants/contacts';
import helpers from 'src/helpers';
import modalFormsStyle from 'src/views/management/CustomerDetailsView/ModalForms/modalForms.style';

function ModalForms({
  classes,
  onOpenModal,
  openModal,
  loading = false,
  contact = null,
}) {
  const dispatch = useDispatch();
  const [readdConfirmed, setReaddConfirmed] = useState(false);

  const {
    allCustomerCategoriesList,
    formAddCustomerCatetories,
    allCategoriesLoading,
  } = useSelector((state) => state?.customerCategories || {});

  const {
    loading: loadingContactCategories,
  } = useSelector((state) => state?.contactSettings || {});

  const {
    formExecuteKeyword,
    formAddToGroup,
    contactGroups,
  } = useSelector((state) => state?.customerDetails || {});

  const {
    loading: loadingFormExecuteKeyword,
    selectedKeyword,
  } = formExecuteKeyword || {};

  const {
    loading: loadingFormAddToGroup,
    group,
  } = formAddToGroup || {};

  const {
    loading: loadingFormAddCategory,
    selectetCategoriesToAdd,
  } = formAddCustomerCatetories || {};

  const handleCloseModal = () => {
    onOpenModal('');
    dispatch(setValuesFormAddCustomerCategories({
      selectetCategoriesToAdd: [],
    }));
    dispatch(setValuesFormExecuteKeyword({
      selectedKeyword: null,
    }));
    dispatch(setValuesFormAddToGroup({
      group: '',
    }));
    setReaddConfirmed(false);
  };

  const onSubmitAddCategoriesToContact = async () => {
    const doWhenTry = () => {
      dispatch(setValuesFormAddCustomerCategories({
        selectetCategoriesToAdd: [],
      }));
      dispatch(setCustomerCategoriesQuery({
        page: 1,
      }));
      dispatch(getCustomerCategories());
      handleCloseModal();
    };
    const doWhenCatch = () => {
      dispatch(setValuesFormAddCustomerCategories({
        selectetCategoriesToAdd: [],
      }));
    };
    dispatch(setValuesFormAddCustomerCategories({ loading: true }));
    if (helpers.isEmpty(selectetCategoriesToAdd)) {
      dispatch(addNotification('sendForm', 'You must select at least one category.', NOTIFICATION_STATUS.ERROR));
      dispatch(setValuesFormAddCustomerCategories({ loading: false }));
      return;
    }
    const contactCategoryIds = selectetCategoriesToAdd.map((category) => category.id);
    const addCustomerCategories = {
      contactIds: [contact.id],
      contactCategoryIds,
    };
    dispatch(sendAddCustomerCategories(addCustomerCategories, doWhenTry, doWhenCatch));
  };

  const onSubmitExecuteKeyword = async () => {
    const doWhenTry = () => {
      dispatch(setValuesFormExecuteKeyword({
        selectedKeyword: null,
      }));
      handleCloseModal();
    };
    const doWhenCatch = () => {
      dispatch(setValuesFormExecuteKeyword({
        selectedKeyword: null,
      }));
    };

    dispatch(setValuesFormExecuteKeyword({ loading: true }));

    if (helpers.isEmpty(selectedKeyword)) {
      dispatch(addNotification('executeKeywordForm', 'You must select a keyword.', NOTIFICATION_STATUS.ERROR));
      dispatch(setValuesFormExecuteKeyword({ loading: false }));
      return;
    }

    const executeKeywordData = {
      contactId: contact.id,
      keywordId: selectedKeyword.id,
    };

    dispatch(sendExecuteKeyword(executeKeywordData, doWhenTry, doWhenCatch));
  };

  const onSubmitAddToGroup = async (executeJoinActions) => {
    const doWhenTry = () => {
      dispatch(setValuesFormAddToGroup({
        group: '',
      }));
      dispatch(getContactGroups(contact.id));
      handleCloseModal();
    };
    const doWhenCatch = () => {
      dispatch(setValuesFormAddToGroup({
        group: '',
      }));
    };
    dispatch(setValuesFormAddToGroup({ loading: true }));
    if (helpers.isEmpty(group)) {
      dispatch(addNotification('sendForm', 'You must select a group.', NOTIFICATION_STATUS.ERROR));
      dispatch(setValuesFormAddToGroup({ loading: false }));
      return;
    }

    const selectedGroupId = group?.value ? group.value : null;
    const addGroupMember = {
      contactId: contact.id,
      executeJoinActions,
      addAgainIfAlreadyInGroup: true,
      source: 'Chat Screen',
    };

    dispatch(sendAddContactToAGroup(selectedGroupId, addGroupMember, doWhenTry, doWhenCatch));
  };

  const handleSubmitSelectNumberToCall = (customerId, values, doWhenTry, doWhenCatch) => {
    // Show "Calling you at..." modal immediately before API call starts
    // (don't wait for API success like the callback would)
    onOpenModal(CONTACT_MODAL_FORM_NAMES.MODAL_CALLING_YOU_TO_CONNECT_YOU_WITH);

    // On error (e.g. CP Voice Calling disabled or no forwarding number),
    // close the "Calling you..." modal so it doesn't contradict the error
    // snackbar. Still run any caller-supplied catch handler.
    const handleCatch = (e) => {
      handleCloseModal();
      if (doWhenCatch) {
        doWhenCatch(e);
      }
    };

    dispatch(callFromCP(
      customerId,
      values?.phoneNumber?.value,
      doWhenTry,
      handleCatch
    ));
  };

  return (
    <>
      <ModalDialog
        onClose={handleCloseModal}
        isVisible={openModal === 'ModalExecuteKeyword'}
        loading={loadingFormExecuteKeyword}
        content={(
          <ExecuteKeywordModal
            loading={loadingFormExecuteKeyword}
            classes={classes}
            selectedKeyword={selectedKeyword}
            customer={contact}
          />
        )}
        closeText="Cancel"
        okText="Execute"
        onOk={onSubmitExecuteKeyword}
        title={`Execute Keyword for ${contact?.firstName || ''} ${contact?.lastName || ''}`}
        largeModal={false}
      />
      <ModalDialog
        onClose={handleCloseModal}
        isVisible={openModal === 'ModalAddCategory'}
        loading={loadingFormAddCategory || loadingContactCategories || allCategoriesLoading}
        content={(
          <AddCategoryModal
            loading={loadingFormAddCategory || loadingContactCategories || allCategoriesLoading}
            classes={classes}
            selectedCategories={selectetCategoriesToAdd}
            attachedCategories={allCustomerCategoriesList}
          />
        )}
        closeText="Cancel"
        okText="Add"
        onOk={onSubmitAddCategoriesToContact}
        title={`Add Categories to ${contact?.firstName || ''} ${contact?.lastName || ''}`}
        largeModal={false}
      />
      <ModalDialog
        onClose={handleCloseModal}
        isVisible={openModal === 'ModalAddToGroup'}
        loading={loading || loadingFormAddToGroup}
        content={(
          <AddToGroupModalChat
            loading={loading || loadingFormAddToGroup}
            classes={classes}
            group={group}
            contactGroups={contactGroups}
            contactId={contact?.id}
            readdConfirmed={readdConfirmed}
            onReaddConfirmedChange={setReaddConfirmed}
          />
        )}
        closeText="Cancel"
        okText="Add"
        onOk={() => { }}
        okButtonProps={{
          disabled: !group || (group?.isAlreadyMember && !readdConfirmed),
        }}
        popConfirmProps={{
          title: 'Execute Join Actions?',
          okProps: {
            form: 'formAddToGroup',
            type: 'primary',
          },
          onConfirm: () => { onSubmitAddToGroup(true); },
          cancelText: 'Cancel',
          cancelClass: 'grey',
          thirdBtnText: 'No',
          thirdBtnProps: {
            form: 'formAddToGroup',
            type: 'primary',
          },
          onThirdBtn: () => { onSubmitAddToGroup(false); }
        }}
        title={`Add ${contact?.firstName || ''} ${contact?.lastName || ''} to a Group`}
        largeModal={false}
      />
      <ModalDialogVideo
        onClose={handleCloseModal}
        isVisible={openModal === 'ModalDialogVideo'}
        videosrc="https://player.vimeo.com/video/1069660533"
        title="How to use Connections"
        largeModal
      />
      <SelectNumberToCall
        loading={loading}
        contact={contact}
        visibleModalForm={openModal}
        onCloseModal={handleCloseModal}
        onSubmitFormRequest={handleSubmitSelectNumberToCall}
      />
      <CallingYouToConnectYouWith
        loading={loading}
        contact={contact}
        visibleModalForm={openModal}
        onCloseModal={handleCloseModal}
        onSubmitFormRequest={handleCloseModal}
      />
    </>
  );
}

ModalForms.propTypes = {
  classes: PropTypes.object.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  openModal: PropTypes.string,
  loading: PropTypes.bool,
  contact: PropTypes.object,
};

export default withStyles(ModalForms, modalFormsStyle, { withTheme: true });
